import {AppRegistry} from 'react-native';
// Suppress useNativeDriver warning on web - it's expected and animations fall back to JS
// React Navigation drawer uses useNativeDriver which doesn't exist on web
import {Platform} from 'react-native';
//-----------------------------------------------------------------------------
// Firebase initialization for web platform
// Native platforms auto-configure via google-services.json / GoogleServices-Info.plist
import {initializeApp} from '@react-native-firebase/app';

if (Platform.OS === 'web') {
  const firebaseConfigString = process.env.FIREBASE_CONFIG;
  if (firebaseConfigString) {
    try {
      const firebaseConfig = JSON.parse(firebaseConfigString);
      // RN Firebase validation requires databaseURL even though Firebase SDK doesn't need it
      // See: https://github.com/invertase/react-native-firebase/issues/8237
      if (!firebaseConfig.databaseURL && firebaseConfig.projectId) {
        firebaseConfig.databaseURL = `https://${firebaseConfig.projectId}.firebaseio.com`;
      }
      initializeApp(firebaseConfig);
    } catch (e) {
      console.error('Failed to initialize Firebase:', e);
    }
  }
}
//-----------------------------------------------------------------------------
// New scoped icon packages (v12+) - Web font setup
// https://github.com/oblador/react-native-vector-icons/blob/master/docs/SETUP-WEB.md
import fontAwesome6Brands from '@react-native-vector-icons/fontawesome6/fonts/FontAwesome6_Brands.ttf';
import fontAwesome6Regular from '@react-native-vector-icons/fontawesome6/fonts/FontAwesome6_Regular.ttf';
import fontAwesome6Solid from '@react-native-vector-icons/fontawesome6/fonts/FontAwesome6_Solid.ttf';
import ioniconsFont from '@react-native-vector-icons/ionicons/fonts/Ionicons.ttf';
import materialDesignIconsFont from '@react-native-vector-icons/material-design-icons/fonts/MaterialDesignIcons.ttf';
import materialIconsFont from '@react-native-vector-icons/material-icons/fonts/MaterialIcons.ttf';

//-----------------------------------------------------------------------------
// IMPORTANT: Import gesture handler and reanimated BEFORE other imports for web compatibility
import 'react-native-gesture-handler'; // Must be first for web drawer navigation to work
import 'react-native-reanimated'; // Must be imported early to install the worklets runtime
if (Platform.OS === 'web') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('useNativeDriver')) {
      return; // Suppress this specific warning
    }
    originalWarn.apply(console, args);
  };
}

import App from './App';
import appConfig from './app.json';

const appName = appConfig.name;
// DIS-1742: each family name below must be the postScriptName the modular
// @react-native-vector-icons package asks for. createIconSet() resolves
// Platform.select({android: fontBasename, default: postScriptName}), so web uses
// the postScriptName. MaterialIcons' is 'MaterialIcons-Regular'; declaring the
// 'MaterialIcons' basename the deprecated react-native-vector-icons used left
// every <Icon type="material" /> rendering as tofu.
const iconFontStyles = `@font-face {
    src: url(${materialIconsFont});
    font-family: MaterialIcons-Regular;
  }
  @font-face {
    src: url(${materialDesignIconsFont});
    font-family: MaterialDesignIcons;
  }
  @font-face {
    src: url(${materialDesignIconsFont});
    font-family: MaterialCommunityIcons;
  }
  @font-face {
    src: url(${ioniconsFont});
    font-family: Ionicons;
  }
  @font-face {
    src: url(${fontAwesome6Solid});
    font-family: FontAwesome6Free-Solid;
  }
  @font-face {
    src: url(${fontAwesome6Regular});
    font-family: FontAwesome6Free-Regular;
  }
  @font-face {
    src: url(${fontAwesome6Brands});
    font-family: FontAwesome6Brands-Regular;
  }`;

// Create a stylesheet
const style = document.createElement('style');
style.type = 'text/css';

// Append the iconFontStyles to the stylesheet
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

// Inject the stylesheet into the document head
document.head.appendChild(style);
//-----------------------------------------------------------------------------

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
